import { z } from "zod";
import { AuditableDomainEntitySchema, DomainModelSchema } from "../types";
import { ProductType } from "@/constants/ProductType";

export const TankCalibrationSchema = AuditableDomainEntitySchema.extend({
  millimetres: z.number(),
  litres: z.number(),
});

export type TankCalibration = z.infer<typeof TankCalibrationSchema>;

export const TankTechnicalDetailsSchema = DomainModelSchema.extend({
  name: z.string(),
  maxFlowRateLitresPerMinute: z.number(),
  maxSlowPumpingFlowRateLitresPerMinute: z.number(),
  litresPerMillimetre: z.number(),
  overfillMillimetres: z.number(),
  overfillLitres: z.number(),
  highHighLevelAlarmMillimetres: z.number(),
  highHighLevelAlarmLitres: z.number(),
  highLevelAlarmMillimetres: z.number(),
  highLevelAlarmLitres: z.number(),
  operationalLevelMillimetres: z.number(),
  operationalLevelLitres: z.number(),
  maximumWorkingLevelMillimetres: z.number().nullable().optional(),
  maximumWorkingLevelLitres: z.number().nullable().optional(),
  workingLevelMillimetres: z.number().nullable().optional(),
  workingLevelLitres: z.number().nullable().optional(),
  operatorLevelAlarmMillimetres: z.number(),
  operatorLevelAlarmLitres: z.number(),
  nearOperationalLevelMillimetres: z.number(),
  nearOperationalLevelLitres: z.number(),
  midFillLevelMillimetres: z.number(),
  midFillLevelLitres: z.number(),
  slowPumpLevelMillimetres: z.number(),
  slowPumpLevelLitres: z.number(),
  lowLevelAlarmMillimetres: z.number(),
  lowLevelAlarmLitres: z.number(),
  product: z.nativeEnum(ProductType),
  lowLowLevelAlarmMillimetres: z.number(),
  lowLowLevelAlarmLitres: z.number(),
  tankStatus: z.string().nullish(),
  tankBottomLevelMillimetres: z.number(),
  tankBottomLevelLitres: z.number(),
  ifrw: z.number(),
  chartId: z.string().nullable(),
  terminalId: z.number().nullish(),
  tankCalibrations: z.array(TankCalibrationSchema),
});

export type TankTechnicalDetails = z.infer<typeof TankTechnicalDetailsSchema>;
